import numeral from "numeral";

numeral.register("locale", "custom", {
    delimiters: {
        thousands: ".",
        decimal: ",",
    },
    abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t",
    },
    ordinal: () => {
        return "";
    },
    currency: {
        symbol: "€",
    },
});

numeral.locale("custom");

export const createNumeralValueFromString = (value: string): number => {
    return numeral(value).value() ?? 0;
};

export default numeral;
